import {
  format,
  formatDistanceToNowStrict,
  formatDuration,
  formatDistance,
} from 'date-fns'
import { enGB, enUS } from 'date-fns/locale'

import { getCurrentLocale } from '@mc/i18n'

import i18nInstance from 'i18n/i18nInstance'

const t = i18nInstance.getFixedT(null, '@mc/next')

export const getInstructorTitle = (instructors: { name: string }[]) => {
  if (
    !instructors ||
    !Array.isArray(instructors) ||
    instructors.length > 2 ||
    instructors.length === 0
  ) {
    return ''
  }

  return instructors.length === 1
    ? instructors[0].name
    : t('sessions.common.twoInstructors', {
        1: instructors[0].name,
        2: instructors[1].name,
      })
}

const locales = {
  'en-US': enUS,
  'en-GB': enGB,
  // TODO: scalability ?
} as const

const currentLocale =
  getCurrentLocale() in locales
    ? locales[getCurrentLocale() as keyof typeof locales]
    : undefined

const s = 60
const h = s * 60
const getHours = (time: number) => Math.floor(time / h)
const getMinutes = (time: number) => Math.round((time % h) / s)

export const formatDate = (date: Date) =>
  format(date, 'MMM do, yyyy', { locale: currentLocale })

export const formatDateInDaysFromNow = (date: number | Date) =>
  formatDistanceToNowStrict(date, {
    roundingMethod: 'ceil',
    unit: 'day',
    locale: currentLocale,
  })

export const formatDateInRelativeUnits = (date: number | Date) =>
  formatDistanceToNowStrict(date, {
    addSuffix: true,
    locale: currentLocale,
  })

export const formatTaskDuration = (durationSeconds: number) =>
  formatDuration({
    hours: getHours(durationSeconds),
    minutes: getMinutes(durationSeconds),
  })

export const formatPostDate = (date: number | Date) =>
  formatDistance(date, new Date(), {
    addSuffix: true,
    locale: currentLocale,
  })

export const formatPST = (date: Date, dateFormat = 'MMMM d') =>
  format(
    new Date(
      date.toLocaleString(getCurrentLocale(), {
        timeZone: 'America/Los_Angeles',
      }),
    ),
    dateFormat,
    { locale: currentLocale },
  )
